import { DotsThreeVertical } from '@remarkable/ark-icons';
import { createColumnHelper } from '@tanstack/react-table';
import type { EnterpriseDomain } from 'src/api/endpoints/cloudEnterpriseAdminApi.types';
import { Button } from 'src/components';
import { DomainEditMenu } from './DomainEditMenu';
import { DomainsTableCompleteMigration } from './DomainsTableCompleteMigration';

const getVerificationStatus = (
  status: EnterpriseDomain['verificationStatus']
) => {
  if (status === 'IDLE') {
    return 'Idle';
  }
  if (status === 'IN_PROGRESS') {
    return 'In progress';
  }

  if (status === 'OK') {
    return 'Ok';
  }

  if (status === 'HOST_UNREACHABLE') {
    return 'Host unreachable';
  }
  return 'Invalid';
};

const columnHelper = createColumnHelper<EnterpriseDomain>();

export const domainsTableColumns = [
  columnHelper.accessor((data) => data.address, {
    id: 'domain',
    header: 'Domain',
    meta: {
      colWidth: 'w-1/5',
      fullWidth: true,
      truncate: false,
    },
    cell: ({ row }) => (
      <div>
        <div>
          Domain {row.index + 1}{' '}
          {row.original.isPrimary && (
            <span className="text-blue-500" title="Primary domain">
              (Primary)
            </span>
          )}
        </div>

        <div className="text-muted" title="Verified domain">
          {row.original.address}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor(
    (data) => getVerificationStatus(data.verificationStatus),
    {
      id: 'verified',
      header: 'Verification',
    }
  ),
  columnHelper.accessor((data) => data.migrationEnabled, {
    id: 'migrationStatus',
    header: 'Migration status',
    cell: ({ row }) => {
      if (row.original.homeRealmDiscoveryEnabled) {
        return <div>Completed</div>;
      }

      if (row.original.migrationEnabled) {
        return <DomainsTableCompleteMigration domain={row.original} />;
      }

      // TODO: Decide if we need the "Start migration" action here or if this is handled elsewhere
      return <div>Not started</div>;
    },
  }),
  columnHelper.display({
    id: 'edit',
    header: 'Edit',
    meta: {
      align: 'center',
      colWidth: 'w-[50px]',
      truncate: false,
    },
    cell: ({ row }) => (
      <DomainEditMenu domain={row.original}>
        <Button
          variant="tertiary-neutral"
          size="small"
          className="!rounded-sm data-[state=open]:bg-paper-3"
        >
          <DotsThreeVertical />
        </Button>
      </DomainEditMenu>
    ),
  }),
];
